'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _groupByKey = require('../object/groupByKey');

var _groupByKey2 = _interopRequireDefault(_groupByKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contracts) {
    var extraRemoved = contracts.map(function (contract) {
        return {
            amount_per_point: contract.amount_per_point,
            barrier: contract.barrier,
            barriers: contract.barriers,
            contract_category: contract.contract_category,
            contract_category_display: contract.contract_category_display,
            contract_display: contract.contract_display,
            contract_type: contract.contract_type,
            expiry_type: contract.expiry_type,
            forward_starting_options: contract.forward_starting_options,
            high_barrier: contract.high_barrier,
            last_digit_range: contract.last_digit_range,
            low_barrier: contract.low_barrier,
            min_contract_duration: contract.min_contract_duration,
            max_contract_duration: contract.max_contract_duration,
            stop_type: contract.stop_type,
            stop_loss: contract.stop_loss,
            stop_profit: contract.stop_profit
        };
    });

    var groupByCategory = (0, _groupByKey2.default)(extraRemoved, 'contract_category');
    var allCategory = Object.keys(groupByCategory);
    allCategory.forEach(function (c) {
        var relatedContracts = groupByCategory[c];
        var groupByType = (0, _groupByKey2.default)(relatedContracts, 'contract_type');
        groupByCategory[c] = groupByType;
    });

    return groupByCategory;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/trade/normalizedContractFor.js
// module id = 394
// module chunks = 0